import * as React from 'react';
import * as _ from 'lodash';
import NotificationActions from '../../../actions/NotificationActions';
import PosCartActions from '../../../actions/PosCartActions';
import PrintActions from '../../../actions/PrintActions';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';
import PopupActions from '../../../actions/PopupActions';

import UserStore from '../../../stores/UserStore';
import PosCartStore from '../../../stores/PosCartStore';
import PosStore from '../../../stores/PosStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import Price from '../../form/Price.react';
import CheckoutBiotrackFail from './CheckoutBiotrackFail.react';
import CheckoutCompleted from './CheckoutCompleted.react';
import CheckoutExpiredItemsWarning from './CheckoutExpiredItemsWarning.react';
import CheckoutInputElectronic from './CheckoutInputElectronic.react';
import CheckoutInputPrice from './CheckoutInputPrice.react';
import CheckoutOverlimitWarning from './CheckoutOverlimitWarning.react';
import CheckoutSignature from './CheckoutSignature.react';
import ElectronicCheckout from './electronic/ElectronicCheckout.react';
import MNApprovalCode from './MNApprovalCode.react';
import UserActions from '../../../actions/UserActions';
import BirthdateCheckModal from './BrithdateCheckModal';
import JoryCancel from './electronic/JoryCancel.react';

class Checkout extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            paymentVisible : false,
            notifyVisible: false,
            educationalVisible: false,
            loading : false,
            cartReloading: false,

            pin     : '',
            pinUserId : '',

            cash    : {
                str : '',
                int : 0,
            },
            debit   : {
                str : '',
                int : 0,
            },
            electronic: {
                str: PosCartStore.getPaymentData().ElectronicAmount ? 
                    PosCartStore.getPaymentData().ElectronicAmount.toString() : null,
                int: PosCartStore.getPaymentData().ElectronicAmount,
                type: PosCartStore.getPaymentData().ElectronicType,
            },
            creditcard: {
                str: '',
                int: 0,
            },
            check: {
                str: '',
                int: 0,
            },
            authCode: '',
            change  : '',
            signups : {},
            completed : false,
            error     : false,
            ApprovalCode: '',
            biotrackFail : false,
            overLimit    : false,
            paidElectronic: false,
            selectedElectronicPayment: false,
            location : UserStore.getState().selectedLocation,
            isElectronicVerified: false,
            showElectronicCheckout: false,
            electronicPaymentData: false,
            paymentCallback: this.pay,
            showEmailReceipt: false,
            showSignature: false,
            authRequired: false,
            expiredItemsInCart: false,
            educationalMaterialsAccepted: null,
            birthdateCheckComplete: false,
            showBirthdateCheck: false,
            cartStoreLoading: false,
            joryLoading: false,
            tip: PosCartStore.getState().TipAmount,
        };

        this.startCheckout = this.startCheckout.bind(this);
        this.accept = this.accept.bind(this);
        this.reject = this.reject.bind(this);
        this.showPayment = this.showPayment.bind(this);
        this.showNotify = this.showNotify.bind(this);
        this.notify = this.notify.bind(this);
        this.hide = this.hide.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onExactCash = this.onExactCash.bind(this);
        this.checkAllotment = this.checkAllotment.bind(this);
        this.checkPinNumber = this.checkPinNumber.bind(this);
        this.checkGuestOut = this.checkGuestOut.bind(this);
        this.verifyElectronicPayment = this.verifyElectronicPayment.bind(this);
        this.getSignups = this.getSignups.bind(this);
        this.pay = this.pay.bind(this);
        this.getElectronicOptions = this.getElectronicOptions.bind(this);
        this.validateAndPay = this.validateAndPay.bind(this);
        this.showApprovalCode = this.showApprovalCode.bind(this);
        this.checkAuthCode = this.checkAuthCode.bind(this);
        this.closePaymentPopup = this.closePaymentPopup.bind(this);
        this.checkCartForExpiredItems = this.checkCartForExpiredItems.bind(this);
        this.calcUserCartTotal = this.calcUserCartTotal.bind(this);
        this.onCartStoreChange = this.onCartStoreChange.bind(this);
        this.onExactDebit = this.onExactDebit.bind(this);
    }

    componentDidMount() {
        PosCartStore.addChangeListener(this.onCartStoreChange);
        this.setState({ 
            cartStoreLoading: PosCartStore.getState().loading,
        });

        var lspId = UserStore.getState().user.LspId;
        if ((lspId === 1079 || lspId === 1091)){
            this.setState({ paymentCallback: this.pay });
        }
        var electronic = {
            str: '',
            int: 0,
            type: '',
        };
        const electronicOptions = this.getElectronicOptions();
        if (electronicOptions.length > 0) {
            electronic = {
                str : '',
                int : 0,
                type: electronicOptions[0].value,
                icon: electronicOptions[0].icon,
            };
        }	

        this.setState({ 
            paidElectronic: false,
            electronic: electronic,
        });
    }

    onCartStoreChange() {
        const {loading: cartStoreLoading, payment, TipAmount: tip } = PosCartStore.getState();

        let stateUpdate = { cartStoreLoading, tip };

        if (!!payment &&
            !!payment.ElectronicAmount &&
            !!UserStore.getState().selectedLocation.IntegratedDebitProvider &&
            PosCartStore.getPaymentData().ElectronicType === UserStore.getState().selectedLocation.IntegratedDebitProvider
        ) {
            stateUpdate.debit = {
                str: payment.ElectronicAmount.toFixed(2),
                int: parseInt(payment.ElectronicAmount * 100),
            };
        }

        this.setState(stateUpdate);
    }

    showApprovalCode() {
        let hasCannibis = this.props.cart.filter(x => x.CannbisProduct.toLowerCase() === 'yes').length > 0;
        return UserStore.getState().selectedLocation.UseMn && hasCannibis;
    }

    getSignups() {
        if(!location.RegisterForLoyaltyPopup) {
            AjaxPromises.POST(PosEndPoints.GET_SIGNUPS, UserStore.getApiData({
                CustomerId: this.props.guest.Guest_id,
            })).then(res => {
                if (res.Result) {
                    let signups = {};
                    if (res.Data) {
                        res.Data.map(x => {
                            signups[x] = false;
                        });
                    }

                    this.setState({ signups });
                }
            });
        }
    }

    showNotify() {
        this.setState({ notifyVisible : true, paymentVisible : false});
    }
    
    notify() {
        this.hide();
        AjaxPromises.POST(PosEndPoints.NOTIFY_ORDER_READY, UserStore.getApiData({
            CustomerId: this.props.guest.Guest_id,
        })).then(res => {
            if (res.Result) {
                NotificationActions.success('Customer Notified!');
            } else {
                NotificationActions.error('Error notifying!');
                NotificationActions.error(res.Message);
            }
        });
    }

    startCheckout() {
        if (this.state.cartStoreLoading) {
            return;
        }
        
        const selectedLocation = UserStore.getState().selectedLocation;
        if (!selectedLocation.EducationalMaterialsAcceptReject && !selectedLocation.EducationalMaterialsAcceptOnly) {
            this.showPayment();
        } else {
            this.setState({ educationalVisible: true });
        }
    }

    accept() {
        this.setState({ educationalMaterialsAccepted: true, educationalVisible: true });
        this.showPayment();
    }

    reject() {
        this.setState({ educationalMaterialsAccepted: false, educationalVisible: true });
        this.showPayment();
    }

    showPayment() {
        
        const selectedLocation = UserStore.getState().selectedLocation;
        const guest = this.props.guest;

        if (this.props.cart.length === 0) {
            return;
        }

        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical
            && UserActions.isMMJLicenseExpired(this.props.guest)) {

            NotificationActions.error('Patient\'s MMJ License has expired. Please update expiration date to proceed with transaction.');
            return;
        }

        this.setState({ cartReloading: true });

        this.getSignups();
        $('.pos-header').css({ 'z-index' : '0' });
        $('.pos-sidebar').css({ 'z-index' : '0' });

        if (PosCartStore.getPaymentData().ElectronicType) {
            var showLoading = setTimeout(() => this.setState({ cartReloading: true }), 1000);
            (UserStore.getState().selectedLocation.StatefulCheckout
                ? PosCartActions.calcUserCartTotal(guest.Guest_id, guest.ShipmentId, true)
                : PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId)).then(() => {
                clearTimeout(showLoading);
                let type = _.find(this.getElectronicOptions(), x => x.value === PosCartStore.getPaymentData().ElectronicType);
                let requireSignatrue = UserStore.getState().selectedLocation.RequireSignatureCheck;
                let electronic = {
                    str : '',
                    int : 0,
                };
                let debit = {
                    str : '',
                    int : 0,
                };
                if (
                    PosCartStore.getPaymentData().ElectronicType === UserStore.getState().selectedLocation.IntegratedDebitProvider &&
                        !!UserStore.getState().selectedLocation.IntegratedDebitProvider
                ) {
                    debit = {
                        str: PosCartStore.getPaymentData().ElectronicAmount ? PosCartStore.getPaymentData().ElectronicAmount.toFixed(2) : null,
                        int: PosCartStore.getPaymentData().ElectronicAmount ? PosCartStore.getPaymentData().ElectronicAmount * 100 : null,
                        type: PosCartStore.getPaymentData().ElectronicType,
                    };
                } else {
                    electronic = {
                        str: PosCartStore.getPaymentData().ElectronicAmount ? PosCartStore.getPaymentData().ElectronicAmount.toFixed(2) : null,
                        int: PosCartStore.getPaymentData().ElectronicAmount ? PosCartStore.getPaymentData().ElectronicAmount * 100 : null,
                        type: PosCartStore.getPaymentData().ElectronicType,
                        icon: type ? type.icon : null,
                    };
                }
                this.setState({
                    showSignature: requireSignatrue,
                    paymentVisible: !requireSignatrue,
                    notifyVisible: false,
                    cartReloading: false,
                    electronic,
                    debit,
                    paidElectronic: !!PosCartStore.getPaymentData().ElectronicType,
                    isElectronicVerified: !!PosCartStore.getPaymentData().ElectronicType,
                });
            });
        } else {
            let requireSignatrue = UserStore.getState().selectedLocation.RequireSignatureCheck;
            var loading = setTimeout(() => this.setState({ cartReloading: true }), 1000);
            (UserStore.getState().selectedLocation.StatefulCheckout
                ? PosCartActions.calcUserCartTotal(guest.Guest_id, guest.ShipmentId)
                : PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId)).then(() => {
                clearTimeout(loading);
                this.setState({ 
                    showSignature: requireSignatrue,
                    paymentVisible: !requireSignatrue, 
                    notifyVisible : false, 
                    cartReloading: false });
            });
        }
    }

    hide() {
        $('.pos-header').css({ 'z-index' : '999' });
        $('.pos-sidebar').css({ 'z-index' : '2' });
        this.setState({
            paymentVisible : false,
            notifyVisible : false,
            isElectronicVerified: false,
            showElectronicCheckout: false,
            pin : '',
            pinUserId : '',
        });
    }

    onExactCash() {
        // ga('send', 'event', 'Exact Cash');

        var total = PosCartStore.getCartSummary().roundedDown;
        this.setState({
            cash : {
                str : total.str,
                int : total.int,
            },
        });
    }

    onExactDebit() {
        const total = PosCartStore.getCartSummary().roundedDown;
        this.setState({
            debit: {
                str: total.str,
                int: total.int,
            },
        }, () => this.validateAndPay());
    }

    pay() {
        var location = UserStore.getState().selectedLocation;

        if (this.state.electronic.int > 0 && !this.state.isElectronicVerified) {
            this.verifyElectronicPayment();
            return;
        }

        let electronic = this.state.electronic;
        var data = this.state.electronicPaymentData;
        electronic.recordAmount = true;
        
        if(this.state.debit.int > 0 && location.UseIntegratedDebit) {
            electronic = {
                str: this.state.debit.str,
                type: location.IntegratedDebitProvider,
                recordAmount: false,
            };
            data = null;
        }

        this.setState({ loading: true, joryLoading: location.UseJory }, () => {

            AjaxPromises.POST('api/v2/guest/pay', UserStore.getApiData({
                ElectronicPaid: electronic.str,
                ElectronicPaymentData: data,
                ElectronicPaymentType: electronic.type,
                ShipmentId: this.props.guest.ShipmentId,
                RecordAmountAsElectronicPayment: electronic.recordAmount,
            })).then(res => {
                if (res.Result) {
                    NotificationActions.success('Electronic Payment Success');
                    this.setState({paidElectronic: true, loading: false, joryLoading: false });
                    if (electronic.type === 'jory') {
                        PosCartStore.onJoryPayment(res.Data);
                    }
                    if (electronic.type !== location.IntegratedDebitProvider) {
                        PosCartStore.setPaymentData({
                            ElectronicType: this.state.electronic.type,
                            ElectronicAmount: electronic.str,
                        });
                    }
                } else {
                    if (res.Message === 'Transaction cancelled by user') {
                        NotificationActions.success(res.Message);
                    } else {
                        NotificationActions.error('Electronic Payment Failed');
                        NotificationActions.error(res.Message);
                    }
                    this.setState({ loading: false, paidElectronic: false, isElectronicVerified: false, joryLoading: false });
                }
            });
        });
    }

    priceToInt(val) {
        val = val.replace(/^0+/, '').replace(/[^0-9]/g, '');

        if (val.length < 1) {
            val = '0';
        }

        return val;
    }

    intToPrice(val) {
        if (UserStore.getState().selectedLocation.RoundToNearestNickel) {
            // val is in cents.  a nickel is 5 cents.  divide by 5 gives us "change in nicekls"
            // then we round to number of whole nickels and multiply back out to get cents again.
            val = _.round(val / 5) * 5;
        }

        val = val.toString();

        if (val.length === 1) {
            val = '0.0'+val;
        } else if (val.length === 2) {
            val = '0.'+val;
        } else {
            val = val.slice(0, -2)+'.'+val[val.length - 2]+val[val.length-1];
        }

        return val;
    }

    verifyElectronicPayment() {
        var selectedLocation = UserStore.getState().selectedLocation;
        if(this.state.debit.int > 0 && selectedLocation.UseIntegratedDebit) {
            return;
        }
        
        this.setState({ showElectronicCheckout: true});
    }

    async calcUserCartTotal() {
        if (this.state.loading || this.state.cartStoreLoading) {
            return;
        }
        this.setState({ loading: true });
        const { guest: { Guest_id, ShipmentId} } = this.props;
        PosCartActions.calcUserCartTotal(Guest_id, ShipmentId).then(() => this.setState({ loading: false }));
    }


    checkAllotment(pay=false, checkPinOverride=false) {
        if (!this.isValid() || this.state.loading) {
            return;
        }

        let hasCannabisItemInCart = (this.props.cart).some(cartItem => cartItem.CannbisProduct === 'Yes');
        let allotment = this.props.allotment;
        if(hasCannabisItemInCart) {
            if(this.state.location.EnforceDaysSupplyLimit && (UserStore.getState().selectedLocation.ShowDaysSupplyCalculator)) {
                let daysSupplyInCart = (this.props.cart).reduce((value, cartItem) => value + cartItem.QtySelected * (cartItem.DaysSupply !== '' ? parseFloat(cartItem.DaysSupply) : 0.00), 0.00);
                let daysSupplyRemaining = this.props.guest.DaysSupplyRemaining;
                if(Number.isFinite(daysSupplyInCart) && Number.isFinite(daysSupplyRemaining)) {
                    if(daysSupplyRemaining < daysSupplyInCart || daysSupplyRemaining < 0) {
                        NotificationActions.error(`Unable to checkout. Patient days supply exceeded by ${Math.abs(daysSupplyInCart - daysSupplyRemaining)}.`);
                    } else {
                        this.checkPinNumber(pay, checkPinOverride);
                    }
                } else {
                    NotificationActions.error('Unable to checkout.  Invalid days supply.');
                }
                return;
            } else if (allotment.remaining < 0 && !(UserStore.getState().selectedLocation.ShowDaysSupplyCalculator)) {
                if(this.state.location.EnforcePurchaseLimit) {
                    NotificationActions.addNotification({
                        type : 'error',
                        body : `Unable to checkout. Patient allotment exceeded by ${Math.abs(this.props.allotment.remaining)}g`,
                    });
                } else {
                    this.setState({
                        overLimit : true,
                    });
                }
                return;
            } else {
                this.checkPinNumber(pay, checkPinOverride);
                return;
            }
        } else {
            this.checkPinNumber(pay, checkPinOverride);
        }
    }

    async checkCartForExpiredItems() {
        let payload = {
            serialNumbers: (this.props.cart).map(item => item.SerialNo.toString()),
        };

        let resp = await AjaxPromises.POST('api/v2/inventory/get-expired-inventory-items', UserStore.getApiData(payload));
        if(resp.Result) {
            if (resp.Data.length > 0) {
                this.setState({
                    expiredItemsInCart : true,
                    loading : false,
                }, () => {
                    let expiredItemSerialNumbers = (resp.Data).map(expiredItem => expiredItem.SerialNumber);
                    NotificationActions.addNotification({
                        type : 'error',
                        body : 'Expired items in cart: ' + expiredItemSerialNumbers.join(', ') + '. Please remove the expired items from the cart or enter a valid manager PIN to continue.',
                    });
                });
            } else {
                this.checkAllotment(false);
            }
        }
    }

    checkPinNumber(pay = false, checkPinOverride = false) {
        if (this.state.location.CheckOutPinRequired || checkPinOverride) {
            AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER, UserStore.getApiData({
                PinCode : this.state.pin,
            })).then(res => {
                if (res.Data[0].UserId === 0) {
                    NotificationActions.addNotification({
                        type : 'error',
                        body : 'Invalid PIN number',
                    });
                } else {
                    this.setState({
                        pinUserId : res.Data[0].UserId,
                    }, () => {
                        if (this.validateCart()) {
                            if (pay) {
                                this.pay();
                            } else {
                                this.checkGuestOut();
                            }
                            
                        }
                    });
                }
            });
        } else {
            if (this.validateCart()) {
                if (pay) {
                    this.pay();
                } else {
                    this.checkGuestOut();
                }
            }
        }
    }

    validateAndPay(checkAllotment=true) {
        if (checkAllotment) {
            this.checkAllotment(true);
        } else {
            this.checkPinNumber(true);
        }
        
    }


    validateCart() {
        if (this.state.loading || this.state.completed) {
            return false;
        }
        var cartSummary = PosCartStore.getCartSummary();
        var cash      = this.state.cash;
        var electronic = this.state.electronic;
        var debit     = this.state.debit;
        var check      = this.state.check;
        var creditcard = this.state.creditcard;
        var total     = cartSummary.roundedDown;
        var guest     = this.props.guest;
        var cart      = this.props.cart;

        var prepayment = 0.00;

        if(cartSummary.prepayInfo && cartSummary.prepayInfo.length > 0) {
            prepayment = _(cartSummary.prepayInfo || []).map(p => p.Amount).sum() || 0;
        }
        
        let canadaPrePayInfo = (cartSummary.prepayInfo || []).find(x => x.PrepaymentType === 'canada');
        if(cartSummary.isPreauth || canadaPrePayInfo != null) {
            NotificationActions.addNotification({
                type : 'error',
                body : 'Pre-pay with Dutchie Pay or Canadian prepay is not supported on this version of POS. To accept alternative payment, please cancel this transaction and start again.',
                fullscreen : true,
                sticky : true,
            });
            return false;
        }

        /* don't allow checkout for empty cart */
        if (cart.length === 0) {
            return false;
        }

        if (guest.MJStateIDNo.length < 1 && guest.PatientType === 'Medical') {
            NotificationActions.addNotification({
                type : 'error',
                body : 'Guest does not have a valid MJ State Id number',
                fullscreen : true,
                sticky : true,
            });
            return false;
        }

        var payment = cash.int + debit.int + electronic.int + check.int + creditcard.int + ((prepayment || 0) * 100);
        if (payment < total.int) {
            return false;
        }
        
        if (UserStore.getState().selectedLocation.RequireAuthCodeOnElectronicTransactions) {
            if (this.state.debit && this.state.authRequired) {
                NotificationActions.addNotification({
                    type : 'error',
                    body : 'Must use Auth Code with debit transaction',
                    fullscreen : true,
                    sticky : true,
                });
                return false;
            }
        }

        if(this.state.electronic.int > 0 && !this.state.isElectronicVerified) {
            this.verifyElectronicPayment();
            return false;
        }

        return true;
    }

    checkGuestOut() {
        var guest     = this.props.guest;
        var cart      = this.props.cart;
        var user      = UserStore.getState().user;

        var cartSummary = PosCartStore.getCartSummary();

        var cash    = this.state.cash;
        var debit   = this.state.debit;
        var electronic = this.state.electronic;
        var check      = this.state.check;
        var creditcard = this.state.creditcard;
        var authCode = this.state.authCode;
        var total   = cartSummary.roundedDown;

        var formData         = UserStore.getApiData();
        formData.ShipmentId  = guest.ShipmentId;
        formData.MJStateIDNo = guest.MJStateIDNo;
        formData.TotalItems     = cartSummary.totalItems;
        formData.DiscountAmt    = cartSummary.totalDiscount;
        formData.LoyaltyPoints  = cartSummary.loyaltyApplied;
        formData.TaxAmt         = cartSummary.tax.flt;

        formData.CheckPaid      = check.str;
        formData.CCPaid         = creditcard.str;
        formData.UserId         = user.userId;
        formData.AuthCode       = authCode;

        if (this.state.location.CheckOutPinRequired) {
            formData.PinUserId = this.state.pinUserId;
        }

        formData.TerminalId     = formData.Register;
        formData.DebitPaid      = this.state.debit.str;
        formData.TotalCharges   = total.str;
        formData.Paidamt        = this.state.cash.str;
        formData.TransType      = 'Cash';
        formData.TransId        = '';
        formData.SubTotal       = cartSummary.subTotal.flt;
        formData.ApprovalCode   = this.state.ApprovalCode;

        formData.NetAmt         = 0;
        formData.TaxRt          = 0;

        formData.EducationalMaterialsAccepted = this.state.educationalMaterialsAccepted;
        
        formData.ShowDaysSupplyCalculator = this.state.location.ShowDaysSupplyCalculator;
        formData.CustomerId = this.props.guest.Guest_id;
       
        let keys = Object.keys(this.state.signups);
        if (this.state.signups && keys.length > 0) {
            formData.Signups = keys.filter(x => this.state.signups[x]);
        }

        if (electronic.int > 0) {
            formData.ElectronicPaid = electronic.str;
            formData.ElectronicPaymentData = this.state.electronicPaymentData;
            formData.ElectronicPaymentType = this.state.electronic.type;
        }

        let prepayment = 0;
        if(cartSummary.prepayInfo && cartSummary.prepayInfo.length > 0) {
            prepayment = _(cartSummary.prepayInfo || []).map(p => p.Amount).sum() || 0;            
            let prepaymentType = cartSummary.prepayInfo[0].PrepaymentType;
    
            if((prepayment * 100) > total.int) {
                prepayment = total.flt;
            }

            formData.PrepaymentType = prepaymentType;
            formData.PrepaymentAmount = prepayment;
            formData.ElectronicPaid = (prepayment || 0).toFixed(2);
            formData.ElectronicPaymentData = null;
            formData.ElectronicPaymentType = formData.PrepaymentType;            
        }        

        formData.DueCustomer = this.intToPrice(Math.abs(total.int - (cash.int + debit.int + electronic.int + check.int + creditcard.int + ((prepayment || 0) * 100) - (this.state.tip ? this.state.tip * 100 : 0))));
        
        formData.ReactVersion = React.version;
        this.setState({loading: true});
        AjaxPromises.POST(PosEndPoints.CHECKOUT, formData).then(res => {
            if (res.Data && res.Data[0].ResultId === 1) {

                if (UserStore.getState().selectedLocation.UseBioTrackPOS) {
                    var formData = UserStore.getApiData();
                    formData.PatientScan = guest.MJStateIDNo;
                    formData.ShipmentId = guest.ShipmentId;

                    AjaxPromises.POST(PosEndPoints.BIOTRACK_SCAN_GUEST_OUT,
                        formData
                    );
                }

                if(res.Message) {
                    NotificationActions.success(res.Message);
                }

                res.Data[0].OverThreshold ? NotificationActions.error('Your register is over the threshold, please perform a cash drop') : null;

                this.setState({
                    completed : true,
                    loading : false,
                }, () => {
                    if (PosStore.getState().autoPrintReceipts) {
                        PrintActions.printReceipt(guest.ShipmentId, false, false);
                    }
                });
            } else {
                this.setState({
                    loading : false,
                }, () => {
                    NotificationActions.addNotification({
                        type : 'error',
                        body : res.Message + (res.IntegrationMessage ? '\n' + res.IntegrationMessage : ''),
                    });
                });
            }
        });
    }

    getElectronicOptions() {
        var options = [];
        // if(location.CheckOutCreditCard) {
        //     options.push({ name: 'CREDIT CARD', value: 'credit-card'});
        // }
        if (this.state.location.AcceptHypur) {
            options.push({ name: 'Hypur', value: 'hypur', icon: '/assets/hypur-logo-small.png'});
        }
        if (this.state.location.AcceptCanPay) {
            options.push({ name: 'CanPay', value: 'canpay', icon: '/assets/canpay-logo-small.png'});
        }    
        if (this.state.location.AcceptLinx) {
            options.push({ name: 'Linx', value: 'linx', icon: '/assets/linx-logo-small.png'});
        }
        return options;
    }

    isValid() {
        if (this.props.cart.length === 0) {
            return false;
        }

        if (this.state.location.CheckOutPinRequired && this.state.pin.length === 0) {
            return false;
        }

        if(this.state.location.UseMn 
            //If there's no cannabis items this won't get transmitted to the state so don't require an approval code 
            && (this.props.cart.filter(x => x.CannbisProduct.toLowerCase() === 'yes').length > 0) 
            && (!this.state.ApprovalCode || this.state.ApprovalCode.length != 8) ) {
            return false;
        }

        return true;
    }

    checkAuthCode() {
        if (!UserStore.getState().selectedLocation.RequireAuthCodeOnElectronicTransactions) {
            return;
        }

        this.state.debit.int && this.state.authCode.length == 0 ? this.setState({ authRequired: true }) : this.setState({ authRequired: false });
    }

    closePaymentPopup() {
        if (this.state.loading) {
            return;
        } else {
            this.hide();
        }
    }

    render() {
        var guest       = this.props.guest;

        var allotment   = PosCartStore.getAllotment(guest);
        var cartSummary = PosCartStore.getCartSummary();

        var total       = cartSummary.roundedDown;

        var cash        = this.state.cash;
        var debit       = this.state.debit;
        var electronic  = this.state.electronic;
        var check       = this.state.check;
        var creditcard  = this.state.creditcard;
        var authCode    = this.state.authCode;
        var prepayment = 0.00;

        if(cartSummary.prepayInfo && cartSummary.prepayInfo.length > 0) {
            prepayment = _(cartSummary.prepayInfo || []).map(p => p.Amount).sum() || 0;
            if((prepayment * 100) > total.int) {
                prepayment = total.flt;
            }
        }

        var payment = cash.int + debit.int + electronic.int + check.int + creditcard.int + (prepayment ? prepayment * 100 : 0);

        var change    = payment - total.int - (this.state.tip ? this.state.tip * 100 : 0);

        var disabled  = total.int > payment || total.int === 0 ? true : false;
        var valid     = this.isValid();
        const displayTotal = PosCartStore.splitPrice((total.flt + (this.state.tip || 0)).toFixed(2));

        var location  = this.state.location;
        var lspId     = UserStore.getState().user.LspId;
        var selectedLocation = UserStore.getState().selectedLocation;
        var CheckoutButton;

        var showPayButton = false;
        var disableElectronic = false;

        if(this.state.electronic.int > 0 && !this.state.paidElectronic) {
            showPayButton = true;
        }
        else if(this.state.debit.int > 0 && selectedLocation.UseIntegratedDebit && !this.state.paidElectronic) {
            showPayButton = true;
            disableElectronic = true;
        }        
        

        if(showPayButton) {
            CheckoutButton = (<div
                style={ location.UseJory ? { width: 330 } : {}}
                className={'checkout__check-out '+(allotment.remaining < 0 ? 'btn-red' : 'btn-green')+' '+(!valid ? 'btn-green__disabled' : '')}
                onClick={this.state.loading ? null : this.validateAndPay}
                id={'payButton_'+guest.ShipmentId}    
            >
                {
                    this.state.loading ?
                        <i className='fa fa-spinner fa-pulse' /> :
                        'PAY'
                }
            </div>);            
        } else {
            CheckoutButton = (<div
                style={ location.UseJory ? { width: 330 } : {}}
                className={'checkout__check-out '+(allotment.remaining < 0 ? 'btn-red' : 'btn-green')+' '+(!valid ? 'btn-green__disabled' : '')}
                onClick={() => {
                    if(!this.state.loading) {
                        if (UserStore.getState().selectedLocation.CheckExpirationDate) {
                            this.checkCartForExpiredItems();
                        } else {
                            this.checkAllotment(false);
                        }
                    }
                }}
                id={'checkoutButton_'+guest.ShipmentId}    
            >
                {
                    this.state.loading ?
                        <i className='fa fa-spinner fa-pulse' /> :
                        'CHECKOUT'
                }
            </div>);
        }

        let chargeButton =
            <div className='checkout__charge btn-green' onClick={this.startCheckout}
                id={'chargeButton_'+guest.ShipmentId} >
                {this.state.cartStoreLoading    
                    ? <i className='fa fa-spinner fa-spin' aria-hidden='true' />                          
                    : (
                        <React.Fragment>
                            <div
                                className='checkout__charge--title'>
                                {
                                    'CHARGE'
                                }
                            </div>
                            <Price
                                className='checkout__charge--sum'
                                price={displayTotal.str}
                                allowHidden
                                dollar={true}
                            />
                        </React.Fragment>
                    )
                }
            </div>;


        if(this.state.cartReloading) {
            chargeButton = <div className='checkout__charge btn-green' ><i className='fa fa-spinner fa-pulse' /></div>;
        } else if(selectedLocation.ConfirmBirthdayOnCheckout && !this.state.birthdateCheckComplete) {
            chargeButton = 
            <div className='checkout__charge btn-green'>
                <div
                    className={'checkout__charge--verify'}
                    onClick={() => { this.setState({ showBirthdateCheck: true }); }}>
                        VERIFY BIRTHDATE
                </div>
            </div>;

        }

        const showNotifyButton = UserStore.getState().selectedLocation.UseSprout ||  UserStore.getState().selectedLocation.ApiPreOrderNotify;

        return (

            <div>
                {UserStore.getState().selectedLocation.StatefulCheckout
                    && (
                        <div
                            className={`checkout__getTotal${showNotifyButton ? 'WithNotify' : ''}`}
                            onClick={this.calcUserCartTotal}
                            id={'getTotalButton_'+guest.ShipmentId}
                        >                              
                            <div className='checkout__getTotal--title'>
                                {this.state.cartStoreLoading ? <i className='fa fa-spinner fa-pulse' /> : 'GET TOTAL'}
                            </div>
                        </div>
                    )
                }
                {showNotifyButton &&
                    <div className='checkout__notify' onClick={this.showNotify} >
                        { this.state.cartReloading ?
                            <i className='fa fa-spinner fa-pulse' /> :                     
                            <div className='checkout__notify--title'>NOTIFY</div>
                        }
                    </div>
                }
                { chargeButton }
                
                { this.state.notifyVisible &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content checkout'>
                            <div className='popup-header'>
                                Notify Customer?
                                <div
                                    className='popup-close'
                                    onClick={this.hide}>
                                    <i className="fa fa-times" aria-hidden="true" />
                                </div>
                            </div>
                            <div  style={{height:'20px'}}></div>
                            <div
                                className='checkout__exact btn-green'
                                onClick={this.notify}>
                                    NOTIFY
                            </div>
                            <div
                                className='checkout__exact btn-green'
                                onClick={this.hide}>
                                    CANCEL
                            </div>
                        </div>
                    </div>
                }
                { this.state.educationalVisible &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content checkout'>
                            <div className='popup-header'>
                                Attention!
                                <div
                                    className='popup-close'
                                    onClick={() => {
                                        this.setState({ educationalVisible: false });
                                        this.showPayment();
                                    }}>
                                    <i className="fa fa-times" aria-hidden="true" />
                                </div>
                            </div>
                            <div style={{margin:'10px'}}>
                                Educational materials have been offered to the customer
                            </div>
                            {UserStore.getState().selectedLocation.EducationalMaterialsAcceptReject && [
                                <div
                                    className='checkout__exact btn-green'
                                    onClick={this.accept}>
                                        ACCEPTED
                                </div>,
                                <div
                                    className='checkout__exact btn-green'
                                    onClick={this.reject}>
                                        REJECTED
                                </div>,
                            ]}
                            {UserStore.getState().selectedLocation.EducationalMaterialsAcceptOnly &&
                                <div
                                    className='checkout__exact btn-green'
                                    style={{ width: '320px' }}
                                    onClick={this.accept}>
                                        ACCEPTED
                                </div>
                            }
                        </div>
                    </div>
                }
                {   this.state.showSignature &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content checkout' style={{ 
                            width: '50%', 
                            maxWidth: '700px',
                            height: '400px',
                        }}>
                            <div className='popup-header'>
                                Customer Signature 
                                <div
                                    className='popup-close'
                                    onClick={() => { this.setState({ showSignature: false });}}>
                                    <i className="fa fa-times" aria-hidden="true" />
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                padding: '10px',
                                height: '90%',
                            }}>
                                <CheckoutSignature ShipmentId={guest.ShipmentId} 
                                    onSave={() => { 
                                        this.setState({ showSignature: false,
                                            paymentVisible: true,
                                        });
                                    }}

                                    onCancel={() => {
                                        this.setState({showSignature: false});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    
                }
                {   this.state.showBirthdateCheck &&
                    <BirthdateCheckModal 
                        ShipmentId={guest.ShipmentId}
                        guest={guest}                        
                        UserId={UserStore.getState().user.UserId}
                        onClose={(success) => {
                            this.setState({ showBirthdateCheck: false, birthdateCheckComplete: success});
                        }}
                    />
                    
                }
                { this.state.paymentVisible &&
                <div className='popup popup__transparent'>
                    <div className='popup__content checkout'>
                        <div className='popup-header'>
                            { (lspId !== 1079 && lspId !== 1091) ? 'CHECKOUT' : 'MAKE PAYMENT' }
                            { !this.state.completed &&
                            <div
                                className={`popup-close${this.state.loading ? '__disabled' : ''}`}
                                onClick={this.closePaymentPopup}>
                                <i className="fa fa-times" aria-hidden="true" />
                            </div>
                            }
                        </div>
                        <div>
                
                            { !this.state.completed && !this.state.showElectronicCheckout &&
                        <div>
                            <div className='checkout__total'>
                                <div className='checkout__total--title'>
                                    TOTAL DUE
                                </div>
                                <Price
                                    className='checkout__total--sum'
                                    price={displayTotal.str}
                                    dollar={true} />
                            </div>
                            { allotment.remaining < 0 &&
                                <div className='checkout__overdue'>
                                    Allotment over limit by {Math.abs(allotment.remaining)}g
                                </div>
                            }
                            <CheckoutInputPrice
                                title='CASH PAID'
                                icon='dollar-sign'
                                value={cash}
                                onChange={cash => { this.setState({ cash }); }} />
                            { location.CheckOutDebit &&
                                <CheckoutInputPrice
                                    title='DEBIT PAID'
                                    icon='credit-card'
                                    value={debit}
                                    disabled={this.state.paidElectronic}
                                    onChange={debit => { this.setState({ debit }, () => this.checkAuthCode()); }} />
                            }
                            { location.CheckOutCreditCard &&
                                <CheckoutInputPrice
                                    title='CREDIT PAID'
                                    icon='credit-card'
                                    value={creditcard}
                                    onChange={ creditcard => this.setState({ creditcard })}
                                />
                            }
                            { (location.CheckOutDebit || location.CheckOutCreditCard) &&
                                <CheckoutInputPrice
                                    title='AUTH CODE'
                                    icon='credit-card'
                                    value={authCode}
                                    placeholder='XXXXXX'
                                    ignoreValidation={true}
                                    onChange={authCode => { this.setState({ authCode }, () => this.checkAuthCode()); }}
                                    isRequired={this.state.authRequired} />
                            }
                            { location.CheckOutCheck &&
                                <CheckoutInputPrice
                                    title='CHECK'
                                    icon='money-bill-alt'
                                    value={check}
                                    onChange={check => { this.setState({ check }); }} />
                            }
                            {   prepayment > 0 &&
                                <CheckoutInputPrice
                                    title='BANK TRANSFER'
                                    icon='piggy-bank'
                                    value={{ str: prepayment.toFixed(2), int: prepayment }}
                                    disabled={true}
                                />
                            }                         
                            {   
                                electronic.int > 0 && electronic.type === 'gtipay-remotepay' &&
                                <CheckoutInputPrice
                                    title='BANK TRANSFER'
                                    icon='piggy-bank'
                                    value={{ str: electronic.str, int: electronic.int }}
                                    disabled={true}
                                />
                            }                                                        
                            <CheckoutInputElectronic
                                value={electronic}
                                disabled={disableElectronic}
                                paid={this.state.paidElectronic}
                                options={this.getElectronicOptions()}
                                onChange={electronic => { this.setState({ electronic }); }} />
                            <div className='checkout-input'>
                                <div className='checkout-input__title'>
                                    CHANGE
                                </div>
                                <input
                                    type='text'
                                    style={(change < 0 ? {'color':'rgba(255, 0, 0, 0.75)'} : {} )}
                                    value={this.intToPrice(change)}
                                    placeholder='-'
                                    disabled />
                            </div>
                            { (location.CheckOutPinRequired || this.state.expiredItemsInCart) &&
                                <div className='checkout-input'>
                                    <div className='checkout-input__title'>
                                        PIN
                                    </div>
                                    <input
                                        type='password'
                                        value={this.state.pin}
                                        onChange={e => { this.setState({ pin : e.target.value }); }} />
                                </div>
                            }
                            {
                                this.showApprovalCode() &&
                                <MNApprovalCode 
                                    ApprovalCode={this.state.ApprovalCode}
                                    onApprovalCodeChange={val => this.setState({ ApprovalCode: val })}
                                />
                            }
                            { location.RegisterForLoyaltyPopup && !guest.IsLoyaltyMember && !guest.IsAnonymous &&                                
                            <div
                                className='profile-sidebar__item'
                                onClick={() => { PopupActions.open('loyalty-registration', false, guest); }}>

                                REGISTER FOR LOYALTY
                            </div>                               
                            }
                            {
                                Object.keys(this.state.signups).length > 0 &&
                                <div className='checkout__signup'>
                                    Signup Customer For
                                </div>
                            }
                            {
                                Object.keys(this.state.signups).map((key) => {
                                    return (
                                        <div className='checkout-input'>
                                            <div className='checkout-input__title'>
                                                {key}
                                            </div>
                                            <input
                                                type='checkbox'
                                                onChange={(e) => { 
                                                    let signups = Object.assign({}, this.state.signups);
                                                    signups[key] = e.target.checked;
                                                    this.setState({ signups }); }}
                                                checked={this.state.signups[key]} />
                                        </div>
                                    );
                                })
                            }
                            {location.UseJory
                                && (
                                    <div
                                        className='checkout__exact btn-green'
                                        onClick={this.onExactDebit}>
                                        {this.state.loading
                                            ? <i className='fa fa-spinner fa-pulse' />
                                            : 'EXACT DEBIT'
                                        }
                                    </div>
                                )
                            }
                            <div
                                className='checkout__exact btn-green'
                                onClick={this.onExactCash}>
                                {this.state.loading
                                    ? <i className='fa fa-spinner fa-pulse' />
                                    : 'EXACT CASH'
                                }
                            </div>
                            {CheckoutButton}
                        </div>
                        
                            }

                            <CheckoutCompleted
                                guest={guest}
                                completed={this.state.completed}
                                lspId={lspId}
                                change={this.intToPrice(change)} 
                                cart={this.props.cart}
                            />
                            <CheckoutBiotrackFail
                                biotrackFail={this.state.biotrackFail}
                                guest={guest}
                                onReset={() => { this.setState({ biotrackFail : false }); }} />
                            <CheckoutOverlimitWarning
                                overLimit={this.state.overLimit}
                                allotment={allotment}
                                onConfirm={() => { this.setState({ overLimit : false }, () => { this.checkPinNumber(); }); }}
                                onCancel={() => { this.setState({ overLimit : false }); }} />
                            <CheckoutExpiredItemsWarning
                                expiredItemsInCart={this.state.expiredItemsInCart}
                                onConfirm={() => { this.setState({ expiredItemsInCart : false }, () => { this.checkAllotment(false, true); }); }}
                                onCancel={() => { this.setState({ expiredItemsInCart : false }); }} />
                            {this.state.joryLoading && <JoryCancel ShipmentId={guest.ShipmentId} />}
                            { this.state.showElectronicCheckout && this.state.electronic && this.state.electronic.type &&
                            <ElectronicCheckout
                                onComplete={(data) => {
                                    this.setState({ isElectronicVerified: true, showElectronicCheckout: false, electronicPaymentData: data }, this.state.paymentCallback);
                                }}
                                onCancel={() => this.setState({ isElectronicVerified: false, showElectronicCheckout: false })}
                                cart={this.props.cart}
                                guest={guest}
                                type={this.state.electronic.type}
                            />
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
        );
    }
}

export default Checkout;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/Checkout.react.jsx